import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function About() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 md:py-32 bg-[#FFF8F0] relative overflow-hidden" data-id="element-11">
      {/* Decorative element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#F5EDE0] to-transparent opacity-50 pointer-events-none" data-id="element-12"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1" data-id="element-15">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif mb-6 text-zinc-900 leading-tight" data-id="element-16">
              {t('about.title.part1')}{' '}
              <span className="text-[#D4A843] italic" data-id="element-17">
                {t('about.title.part2')}
              </span>{' '}
              {t('about.title.part3')}
            </h2>
            <div className="w-20 h-[1px] bg-[#D4A843] mb-8" data-id="element-18"></div>
            <p className="text-zinc-700 text-lg leading-relaxed mb-6 font-light" data-id="element-19">
              {t('about.p1.part1')}{' '}
              <strong className="text-zinc-900 font-medium" data-id="element-20">
                Cheers by Lisa
              </strong>
              {t('about.p1.part2')}
            </p>
            <p className="text-zinc-700 text-lg leading-relaxed font-light" data-id="element-21">
              {t('about.p2')}
            </p>

            <div className="mt-10" data-id="element-22">
              <img src="https://cdn.magicpatterns.com/uploads/9kPEnQk3qpn3pap79A2DDd/lisa_logo.jpg" alt="Cheers by Lisa Signature" className="h-16 opacity-80 grayscale contrast-200 mix-blend-screen" data-id="element-23" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="order-1 lg:order-2 relative" data-id="element-24">
            <div className="aspect-[4/5] relative rounded-t-full overflow-hidden border border-amber-200 p-2" data-id="element-25">
              <div className="w-full h-full rounded-t-full overflow-hidden relative" data-id="element-26">
                <div className="absolute inset-0 bg-[#D4A843]/10 mix-blend-overlay z-10" data-id="element-27"></div>
                <img src="https://cdn.magicpatterns.com/uploads/x4yLXC3z9V2tqmxJKT1coz/lisaa.jpg" alt="Lisa - Owner of Cheers by Lisa" className="w-full h-full object-cover object-center" data-id="element-28" />
              </div>
            </div>
            {/* Decorative accents */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 border-l border-b border-[#D4A843] opacity-50" data-id="element-29"></div>
            <div className="absolute -top-6 -right-6 w-24 h-24 border-r border-t border-[#D4A843] opacity-50" data-id="element-30"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}